import $ from 'jquery';
import './vendor/lity.js';
import './vendor/morphext.min.js';
import 'animate.css';

// set social sharing links to open in modal
var permalink = 'https://www.cablelabs.com/thenearfuture/',
    facebookLink = 'http://www.facebook.com/sharer/sharer.php?u=' + permalink,
    twitterLink = 'http://twitter.com/share?text=' + '&url=' + permalink,
    linkedinLink = 'https://www.linkedin.com/shareArticle?mini=true&url=' + permalink,
    width  = 575,
    height = 400,
    left   = ($(window).width()  - width)  / 2,
    top    = ($(window).height() - height) / 2,
    url    = 'https://www.cablelabs.com/thenearfuture/',
    opts   = 'status=1' +
             ',width='  + width  +
             ',height=' + height +
             ',top='    + top    +
             ',left='   + left;

$("#facebook-share").click(function() {
    window.open(facebookLink, 'facebook-share-dialog', opts);
});
$("#twitter-share").click(function() {
    window.open(twitterLink, 'twitter-share-dialog', opts);
});
$("#linkedin-share").click(function() {
    window.open(linkedinLink, 'twitter-share-dialog', opts);
});


function showVideo($this) {
    var youtubeSlug = $this.data('youtube');
    $this.parent('.video').find('.video-embed-container iframe').attr('src', 'https://www.youtube-nocookie.com/embed/' + youtubeSlug + '?rel=0&autoplay=1&showinfo=0');
    setTimeout(function(){$this.parent('.video').find('.video-embed-container').fadeIn(400);}, 100);
}

function hideVideo($this) {
    $this.parent('.video').find('.video-embed-container').fadeOut(400, function() {
        $this.parent('.video').find('.video-embed-container iframe').attr('src', '');
    });
}

function videoSetup() {
    $('.video-link').on('click', function (e) {
        showVideo($(this));
        e.preventDefault();
        e.stopPropagation();
    });
    $(document).on('click', function() {
        $('.video-link').each(function(){
            hideVideo($(this));
        });
    });
}

function getViewportDimensions() {
    var dimensions = new Array();
    dimensions['w'] = $(window).width();
    dimensions['h'] = $(window).height();
    return dimensions;
}

function billboardAspectRatio() {
    var dimensions = getViewportDimensions();
    if(dimensions['w'] > 1024) {
        var billboardWidth = $('.billboard-video-container').width();
        var billboardHeight = Math.floor(billboardWidth * (9/16));
        $('.billboard').height(billboardHeight);
    } else {
        $('.billboard').height('100%');
    }
    $('.billboard-container').addClass('visible');
}

function videoAspectRatio() {
    var maxHeight = 0;
    $('.content-tabs__content').each(function(index, tab) {
        var $tab = $(tab),
            videoWidth =  $tab.find('.videos-container').width(),
            videoHeight = Math.floor(videoWidth * (9/16));

        maxHeight = videoHeight > maxHeight ? videoHeight : maxHeight;
    });
    $('.content-tabs__content').each(function(index, tab) {
        var $tab = $(tab);
        $tab.find('.video').height(maxHeight);
        $tab.find('.video iframe').height(maxHeight);
    });
}

function videoLoader() {
    var dimensions = getViewportDimensions();
    if(dimensions['w'] > 1024 && $('.billboard-video video').length === 0) {
        var video = $('<video class="scale_video" preload="auto" autoplay="" loop="true" muted><source src="/wp-content/themes/cablelabs-v23/btp/videos/near-future-short.mp4" type="video/mp4"></source><source src="/wp-content/themes/cablelabs-v23/btp/videos/near-future-short.webm" type="video/webm"></source></video>');
        $('.billboard-video').append(video);
    } else if(dimensions['w'] <= 1024) {
        if($('.billboard-video video').length > 0) {
            $('.billboard-video video')[0].pause();
        }
        $('.billboard-video').empty();
    }
}

function billboardSmoothScrollSetup() {
     var dimensions = getViewportDimensions();

    $('.billboard-content-next-link').on('click', function(e){
        e.preventDefault();
        var offset = (dimensions['w'] < 768) ? 0 : 0,
            $target = $($(this).attr('href'));
        $('html, body').animate({
            scrollTop: $target.offset().top - offset
        }, 500, function() {
            $('.cl-anchored-subnav-section').removeClass('active');
            $('.cl-anchored-subnav-section.industry-impact').addClass('active');
        });
    });

    $('.get-involved-button').on('click', function(e){
        e.preventDefault();
        var offset = (dimensions['w'] < 768) ? 50 : 80,
            $target = $($(this).attr('href'));
        $('html, body').animate({
            scrollTop: $target.offset().top - offset
        }, 500, function() {
            $('.cl-anchored-subnav-section').removeClass('active');
            $('.cl-anchored-subnav-section.industry-impact').addClass('active');
        });
    });
}

$(".slidingDiv").hide();

$('.show_hide').click(function (e) {
    var $this = $(this);
    $this.closest(".feature-description").find(".slidingDiv").slideToggle("slow");
    var val = $this.text() == "Read More" ? "Read Less" : "Read More";
    $this.hide().text(val).fadeIn("fast");
    e.preventDefault();
});

$(".js-rotating").Morphext({
    // The [in] animation type. Refer to Animate.css for a list of available animations.
    animation: "bounceIn",
    // An array of phrases to rotate are created based on this separator. Change it if you wish to separate the phrases differently (e.g. So Simple | Very Doge | Much Wow | Such Cool).
    separator: ",",
    // The delay between the changing of each phrase in milliseconds.
    speed: 2000,
    complete: function () {
        // Called after the entrance animation is executed.
    }
});

/****PAGE LOAD ACTIONS****/
videoSetup();
videoLoader();
videoAspectRatio();
billboardAspectRatio();
billboardSmoothScrollSetup();


/****RESIZE ACTIONS****/
$(window).resize(function() {
    videoLoader();
    videoAspectRatio();
    billboardAspectRatio();
});
